<template>
    <v-container fluid fill-height>        
        <v-layout col justify-center align-center class="mb-5">
            <v-flex xs4>
                <v-card class="mb-5">
                    <v-card-title class="subheading font-weight-regular justify-space-between">                                              
                        <v-container fluid>
                            <v-layout row wrap align-center justify-center class="text-xs-center">
                                <v-flex d-flex xs12 >
                                    <h3 class="headline">Registrierung</h3>
                                </v-flex>
                                <v-flex d-flex xs12>
                                    <h4 class="subheading pt-3">Registrieren für den Nöcker-Behnk Archiver</h4>
                                </v-flex>                            
                            </v-layout>
                        </v-container>
                    </v-card-title>                                            

                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('email','register')">
                                        {{ errors.first('email', 'register') }}
                                    </span>            
                                </v-flex>
                                <v-text-field
                                    label="Email"
                                    v-model="user.email"
                                    data-vv-scope="register"
                                    data-vv-name="email"
                                    light
                                    color="#000"
                                    v-validate.immediate="rules.email"  
                                ></v-text-field>
                                <span class="caption grey--text text--darken-1">
                                    Bitte die E-Mail für Ihren Account eingeben!
                                 </span>
                            </v-card-text>
                        </v-window-item>

                        <v-window-item :value="2">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('password','register')">
                                        {{ errors.first('password', 'register') }}
                                    </span>            
                                </v-flex>                                
                                <v-text-field
                                    label="Password"
                                    type="password"
                                    v-model="user.password"
                                    data-vv-scope="register"
                                    data-vv-name="password"
                                    v-validate.immediate="rules.password"  
                                ></v-text-field>          
                                <span class="caption grey--text text--darken-1">
                                    Bitte das Passwort für Ihren Account eingeben!                                    
                                </span>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="3">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('name','register')">
                                        {{ errors.first('name', 'register') }}
                                    </span>            
                                </v-flex>                                
                                <v-text-field
                                    label="Nachname"
                                    type="text"
                                    v-model="user.name"
                                    data-vv-scope="register"
                                    data-vv-name="name"
                                    v-validate.immediate="rules.name"  
                                ></v-text-field>          
                                <span class="caption grey--text text--darken-1">
                                    Bitte Ihren Nachnamen für Ihren Account eingeben!                                    
                                </span>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="4">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('company_id','register')">
                                        {{ errors.first('company_id', 'register') }}
                                    </span>            
                                </v-flex>                                
                                <v-autocomplete
                                    v-model="user.company_id"                                    
                                    :items="items"                                                                        
                                    color="blue-grey lighten-2"
                                    label="Select"
                                    item-text="name"
                                    item-value="id"
                                >
                                    
                                    <template
                                        slot="item"
                                        slot-scope="data"
                                    >
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                        </template>
                                        <template v-else>                                            
                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                                <v-list-tile-sub-title v-html="data.item.web"></v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </template>
                                    </template>
                                </v-autocomplete>        
                                <span class="caption grey--text text--darken-1">
                                    Bitte das Passwort für Ihren Account eingeben!                                    
                                </span>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="5">
                            <v-card-text>
                                                           
                                Registrierung erfolgt. Loggen Sie sich ein!
                            </v-card-text>
                        </v-window-item>
                    </v-window>
                   
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                            :disabled="step === 1"
                            flat
                            @click="loginsteps(-1)"
                        >
                            Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="step === 5 || this.errors.has(currentField,'register')"
                            color="grey darken-4"
                            dark
                            depressed
                            @click="loginsteps(1)"
                        >
                            {{currentTitle}}
                        </v-btn>
                      </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    inject: ['$validator'],
    data: () => ({
        step: 1,
        user:{
            email:'',
            password:'',
            name:'',
            company_id:null
        },
        rules:{
            email:'required|email',
            password:'required',
            company_id:'required'
        },
        
    }),

    computed: {
        currentTitle () {
            switch (this.step) {
                case 1: return 'Next'
                case 2: return 'Next'
                case 3: return 'Next'
                case 4: return 'Register'                
            }
        },
        currentField() {
            switch (this.step) {
                case 1: return 'email'
                case 2: return 'password'
                case 3: return 'name'
                case 4: return 'company_id'
            }
        },
        items(){
            return this.$store.getters['auth/authRegistercompanies']
        }
        
    },
    methods:{
        loginsteps(val) {
            this.step += val
            if(this.step ==5){
                this.initMessage()
                if(this.errors.any('register')) {
                    this.setMessage('422',this.errors.all('register'))                            
                    return
                }                    
                this.$store.dispatch('auth/registerUser', this.user)
                    .then(response=>{                           
                        this.setMessage(response.status,"Erfolg! Sie haben sich registriert!")                                                                        
                    }).catch(error => {                    
                        this.setMessage(error.response.status,error.response.data.message)                    
                        
                }) 
                this.$router.push({ 
                        name: 'login'
                    })
            }
        }                    
    },
    created(){
        this.$store.dispatch('auth/getRegistercompanies')
    }
    
    
}
</script>